import {Component, OnInit} from '@angular/core';
import {EImageRole, IImageWrapper} from '../../models/image-wrapper';
import {IShowFromFileOptions} from '../compare-images/show-from-file/show-from-file.component';
import {IPublishAsOerActionParams} from '../../classes/file-handler.abstract';
import {SessionServiceService} from '../services/session-service.service';
import {Router} from '@angular/router';
import {IOerFormularValues} from '../oer-formular/oer-formular.component';
import { LoggerService } from "../services/logger/logger.service";
import { UI_ACTION_CONSTANTS, REPLACEMENT_ACTION_CONSTANTS } from '../services/logger/constants';
import { Console } from 'console';
import { ModuleTrackerService } from '../services/module-tracker.service';

interface ILicensesDropDownMenu {
  name: string;
  version: string;
  deeds: string;
  enum: number;
}

// for now, those interfaces are equivalent, but I guess it might change in the future
export interface IMakeOerParams extends IPublishAsOerActionParams {}

@Component({
  selector: 'app-make-oer',
  templateUrl: './make-oer.component.html',
  styleUrls: ['./make-oer.component.scss']
})
export class MakeOerComponent implements OnInit {

  public readonly showFromFileComponentOptions: IShowFromFileOptions = {
    hideSizeInfo: true
  };

  constructor(
    private _session: SessionServiceService,
    private _logger: LoggerService,
    private _router: Router,
    private moduleTracker: ModuleTrackerService
  ) { }

  ngOnInit() {
  }

  public makeOer(form?: IOerFormularValues): void {
    // A license is always present. Used to differ it from the SubmitEvent which is always fired shortly thereafter
    if (form.license) {
      const shortcutChosenLicense: ILicensesDropDownMenu = form.license;
      const images = this._session.getImages();
      const selectedImageFromFile = this._session.getCurrentlySelectedImageFromFile();
      for(let img of selectedImageFromFile){
        const _indexInArray = images.findIndex(elem => elem === img);
        images.splice(_indexInArray, 1);
        this._session.nextImagesFromFile(images);
        this._session.nextSelectedImageFromFile();
        const params: IMakeOerParams = {
          author: form.author,
          title: form.title,
          affiliation: form.authorAffiliation,
          license: {
            enum: shortcutChosenLicense.enum,
            version: shortcutChosenLicense.version
          },
          description: form.description,
          originUrl: form.originUrl,
          originName: form.originName,
          authorUrl: form.authorUrl,
          role: form.imageRole
        };
        if (form.imageRole === EImageRole.screenshot) {
          params.screenshotData = {
            date: form.screenshot.date,
            description: form.screenshot.description
          };
        }
        this._session.getFileHandler().EnqueuePublishAsOer(img, params);
      }

      // log publish as oer finished ui action
      this._logger.log(UI_ACTION_CONSTANTS.IMAGE_REPLACED, {
        replacementAction: REPLACEMENT_ACTION_CONSTANTS.PUBLISH_AS_OER,
        sourceImage: selectedImageFromFile.map(img => img.source),
        sourceImageRole: EImageRole[form.imageRole],
        sourceImageLicense: `${form.license.name} ${form.license.version}`,
        authorName: form.author,
        authorSite: form.authorUrl,
        authorAffiliation: form.authorAffiliation,
        workTitle: form.title,
        originURL: form.originUrl,
        originName: form.originName,
        screenshotDate: form.screenshot.date && form.screenshot.date.toISOString() || "",
        screenshotDescription: form.screenshot.description || "",
      });



      this.goToMain();
    }
  }

  public getCurrentlySelectedImageFromFile(): IImageWrapper[] {
    return this._session.getCurrentlySelectedImageFromFile();
  }

  public goToMain(): void {
    const activeModule = this.moduleTracker.getActiveModule();
    this._router.navigate([`/${activeModule}`]);
  }

  public getToolbarTitle(): string {
    return this._session.getToolName() + ' ' + this._session.getCurrentToolVersion();
  }
}
